module.exports = __webpack_public_path__ + "static/media/30.13ab120d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/30.svg
// module id = 401
// module chunks = 14